import { switchMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { of } from 'rxjs/observable/of';

import * as types from '@src/store/types';
import * as actions from '@src/store/actions';
import { TOAST_TYPE_ERROR } from '@src/const/common';

export const handleErrorMessages = (action$, store) => action$.pipe(
	ofType(types.CHECK_LOGIN_FAIL),
	switchMap(({ payload }) => {
		const { response = {} } = payload;
		const newActions = [
			actions.handleErrorMessagesDone(),
		];

		const { status } = response;
		const isBrowser = typeof window !== 'undefined';
		const urlParams = isBrowser ? new URLSearchParams(window.location.search) : null;
		const fromCompanyVat = urlParams?.get('fromCompanyVat');

		if (((status === 401) || (status === 403)) && fromCompanyVat) {
			// lineTokenLoginCall 已在 _app.js onError 處理，這裡不走 logout
		} else if (status === 403) {
			newActions.push(...[
				actions.toastShowCall({ message: 'share:auth:message:repeat_login', type: TOAST_TYPE_ERROR }),
				actions.logoutCall(),
			]);
		} else if (status === 401) {
			newActions.push(...[
				actions.toastShowCall({ message: 'share:auth:message:login_error', type: TOAST_TYPE_ERROR }),
				actions.logoutCall(),
			]);
		}

		return newActions;
	}),
	catchError(err => of(actions.handleErrorMessagesFail(err))),
);
